import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import Head from 'react-helmet';
import PropTypes from 'prop-types';

import { RMWContext } from 'app/shared/providers/RMWContext';
import stringHelper from 'app/shared/utils/stringHelper';
import StringConstants from 'app/shared/constants/StringConstants';

// Selectors
import { AppSelectors, RoutingSelectors } from 'app/shared/selectors';

const propTypes = {
    description: PropTypes.string,
    noFollow: PropTypes.bool,
    noIndex: PropTypes.bool,
    title: PropTypes.string,
};

const defaultProps = {
    description: '',
    noFollow: false,
    noIndex: false,
    title: '',
};

const HeadWrapper = ({
    description: customDescription,
    noFollow,
    noIndex,
    title: pTitle,
}) => {
    const hostname = useSelector(state => AppSelectors.makeHostname(state));
    const location = useSelector(state => RoutingSelectors.makeLocation(state));
    const { brand } = useContext(RMWContext);
    const displayBrand = StringConstants.FORMATTED_BRAND_NAMES_RENTAL[brand];
    const defaultDescription = `Use ${displayBrand} to manage applications, screen tenants, ` +
        'collect rent and list your rental property on Zillow, Trulia and HotPads.';
    // Grabs custom meta description, if present OR grabs default description provided above
    const content = customDescription || defaultDescription;

    const title = stringHelper.getPageTitle(pTitle, brand);

    const link = [];

    // default meta data
    const meta = [{
        name: 'description',
        content,
    }];

    // remove any query params (? and &)
    const href = `${hostname}${location.pathname}`.split('?')[0].split('&')[0];

    const getRobotMetaContent = () => {
        const robotContentList = [];

        if (noIndex) {
            robotContentList.push('noindex');
        }

        if (noFollow) {
            robotContentList.push('nofollow');
        }

        return robotContentList.join(', ');
    };

    // set canonical link
    link.push({
        rel: 'canonical',
        href,
    });

    meta.push({
        name: 'robots',
        content: getRobotMetaContent(),
    });

    return (
        <Head
            meta={meta}
            title={title}
            link={link}
        />
    );
};

HeadWrapper.propTypes = propTypes;
HeadWrapper.defaultProps = defaultProps;

export default HeadWrapper;
